import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import "./styles.scss";
import BackArrow from "../../../../Assets/Svg/Auth/BackArrow.svg";
import PDFIcom from "../../../../Assets/Images/pdfImg.png";
import DocIcon from "../../../../Assets/Images/doc.png";
import XlsIcon from "../../../../Assets/Images/xlsx.png";
import MainLayout from "../../../../Layouts/Main";
import ImageModal from "Components/ImageModal";
import { preAssessmentViewAssessment } from "../../../../Redux/Slices/User/userSlice";
import Button from "Components/Button";

function PreAssessmentView() {
  const [data, setData] = useState([]);
  const [insights, setInsights] = useState([]);
  const [feedbacks, setFeedbacks] = useState([]);
  const location = useLocation();
  const { name, id } = location.state || {}

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { AssessmentId } = useParams();
  const outlineButton = {
    width: "auto",
    height: "48px",
    backgroundColor: "white",
    border: "1.5px solid #1F2155",
    textAlign: "center",
    marginRight: "15px",
  };
  const outlineTitle = {
    color: "#1F2155",
    fontSize: "20px",
    fontWeight: "600",
  };
  useEffect(() => {
    getAllModules();
  }, []);

  const getAllModules = () => {
    dispatch(
      preAssessmentViewAssessment({
        assessmentId: AssessmentId,
        callBack: (data) => {
          setInsights(data?.insightdata);
          setFeedbacks(data?.UserFeedbacks || []);
          const groupedData =
            data?.responseData?.sort((a, b) => a - b)?.reduce((acc, item) => {
              if (Object.keys(item).length !== 0) {
                if ((item?.option_id === null || item?.option_id === undefined && item?.is_not_required) && !item?.text_answer) {
                  return acc;
                }
                const category = item.category?.category_name;
                if (category && !acc[category]) {
                  acc[category] = { id: item.category_id };
                }
                item.category?.sub_categories?.forEach((subItem) => {
                  const subCategory = subItem?.subCategory_name;
                  if (subCategory && !acc[category][subCategory]) {
                    acc[category][subCategory] = [];
                  }

                  const filteredQuestions = (subItem?.questions || [])
                    .map((question) => ({
                      ...question,
                      bearing_size: item?.bearing_size,
                      text_answer: item?.text_answer,
                      grease_name: item?.grease_name,
                      grease_size: item?.grease_size,
                      notes: item?.notes
                    }))
                    .filter((question) => {
                      return (
                        question?.text_answer ||
                        question?.options?.[0]?.title ||
                        question?.subOptions?.[0]?.title ||
                        question?.grease_name ||
                        question?.grease_size
                      );
                    });

                  acc[category][subCategory]?.push(...filteredQuestions);
                });

              }
              return acc;
            }, {}) || {};
          setData(groupedData);
        },
      })
    );
  };

  const getAnswerText = (question) => {
    if (!question) return "";

    const bearingSize = question.bearing_size
      ? `${question.bearing_size.charAt(0).toUpperCase() + question.bearing_size.slice(1)} - `
      : "";

    const subOptionTitle = question.subOptions?.[0]?.title || "";
    const hasSubOptions = question.subOptions && question.subOptions.length > 0;
    const hasOptions = question.options && question.options.length > 0;
    const optionTitle = hasOptions ? question.options[0]?.title : "";
    const textAnswer = question.text_answer || "";

    return `${bearingSize}${subOptionTitle} ${hasSubOptions ? "-" : ""} ${optionTitle} ${textAnswer}`.trim();
  };

  const getGreaseInfo = (list) => {
    return list?.grease_name || list?.grease_size || "";
  };

  return (
    <MainLayout>
      <div className="viewAssessment">
        <div className="Header-recommendations">
          <div className="d-flex align-items-center" style={{ width: "100%", justifyContent: "space-between" }}>
            <div style={{display: "flex", alignItems : "center"}}>
              <img
                src={BackArrow}
                alt="backarrow"
                width="25px"
                height="23px"
                onClick={() => navigate(`/pre-assessment/`)}
                style={{
                  marginLeft: "-10px",
                  cursor: "pointer",
                }}
              />
              <h2 className="journey-title ms-2">{name}</h2>
            </div>
            <div className="d-flex">
              <Button
                title="Assessments Tracking"
                buttonStyle={outlineButton}
                titleStyle={outlineTitle}
                onClick={() =>
                  navigate(
                    "/pre-assessment/" +
                    id +
                    "/assessment-journey",
                    {
                      state: {
                        assessmentName:
                          name,
                      },
                    }
                  )
                }
              />
            </div>
          </div>
        </div>
        <br />
        <div className="header">
          <h1 className="left-title">View Assessment</h1>
        </div>
        <div className="viewAssessmentBody">
          {Object.keys(data).map((category, catIndex) => (
            <div className="categoryBox" key={catIndex}>
              <p className="categoryName">{category}</p>
              {Object.keys(data[category]).map(
                (subCategory, subIndex) =>
                  subCategory !== "id" && data[category][subCategory]?.length > 0 && (
                    <div className="subCategoryBox" key={subIndex}>
                      <p className="subCategoryName">{subCategory}</p>
                      {Array.isArray(data[category][subCategory]) &&
                        (data[category][subCategory].length > 0 ? (
                          <>
                            {data[category][subCategory].map((question, quesIndex) => (
                              <div key={quesIndex}>
                                {quesIndex === 0 && (
                                  <p className="question">
                                    {question?.question_id}. {question?.question}{" "}

                                  </p>

                                )}
                                {/* <p>{question?.bearing_size ? `${question?.bearing_size?.charAt(0).toUpperCase() + question?.bearing_size.slice(1)} - ` : ""}  {question?.subOptions[0]?.title} {question?.subOptions && question?.subOptions?.length > 0 && "-"} {question?.options?.[0]?.title} {question?.text_answer ? question?.text_answer : ""}</p> */}
                                {getGreaseInfo(question) ? (
                                  <>
                                    {getAnswerText(question)}
                                    <br />
                                    {getGreaseInfo(question)}
                                  </>
                                ) : (
                                  getAnswerText(question)
                                )}
                              </div>

                            ))}
                            {data[category][subCategory]?.[0]?.notes &&
                              data[category][subCategory]?.[0]?.notes.length > 0 && (
                                <div style={{ marginTop: "10px" }}>
                                  <p className="question" style={{ marginBottom: "5px" }}>Notes</p>
                                  <div>{data[category][subCategory][0].notes}</div>
                                </div>
                              )}
                          </>
                        ) : (
                          data[category][subCategory].map((question, quesIndex) => (
                            <div key={quesIndex}>
                              <p className="question">
                                {question?.question_id}. {question?.question}{" "}
                                {question?.bearing_size ? `(${question?.bearing_size})` : ""}
                              </p>

                              <p>{question?.options?.[0]?.title}</p>
                            </div>
                          ))
                        ))}

                    </div>
                  )
              )}
              {insights?.some(
                (insight) =>
                  insight?.category_id === data[category]?.id &&
                  insight?.comments &&
                  insight?.media_files?.length > 0
              ) && (
                  <div className="subCategoryBox">
                    <p className="subCategoryName">Insights</p>
                    {insights?.map(
                      (insight, index) =>
                        insight?.category_id === data[category]?.id &&
                        insight?.comments && (
                          <div key={index}>
                            <p style={{ marginTop: "10px" }} className="question">
                              {insight?.comments}
                            </p>
                            {insight?.media_files?.map((file, fileIndex) => {
                              const isPDF = file.toLowerCase().endsWith(".pdf");
                              const isDoc = file.toLowerCase().endsWith(".docx");
                              const isxls = file.toLowerCase().endsWith(".xlsx");
                              return (
                                <div key={fileIndex}>
                                  {isPDF ? (
                                    <div className="pdf-container">
                                      <div className="individual-pdf-container">
                                        <a href={file} target="_blank" rel="noopener noreferrer">
                                          <img src={PDFIcom} alt="PDF" width="75px" height="auto" />
                                          <p>Open PDF</p>
                                        </a>
                                      </div>
                                    </div>
                                  ) : isDoc ? (
                                    <div className="pdf-container">
                                      <div className="individual-pdf-container">
                                        <a href={file} target="_blank" rel="noopener noreferrer">
                                          <img src={DocIcon} alt="Doc" width="75px" height="auto" />
                                          <p>Open Doc</p>
                                        </a>
                                      </div>
                                    </div>
                                  ) : isxls ? (
                                    <div className="pdf-container">
                                      <div className="individual-pdf-container">
                                        <a href={file} target="_blank" rel="noopener noreferrer">
                                          <img src={XlsIcon} alt="Xlsx" width="75px" height="auto" />
                                          <p>Open Xlsx</p>
                                        </a>
                                      </div>
                                    </div>
                                  ) : (
                                    <ImageModal src={file} alt={`media-${fileIndex}`} />
                                  )}
                                </div>
                              );
                            })}

                          </div>
                        )
                    )}
                  </div>
                )}
              {feedbacks?.some(
                (fb) =>
                  fb?.categoryId === data[category]?.id &&
                  (fb?.comment?.replace(/<[^>]+>/g, "").trim() || fb?.rating > 0)
              ) && (
                  <div className="subCategoryBox">
                    <p className="subCategoryName">Feedback</p>
                    {feedbacks?.map(
                      (fb, index) =>
                        fb?.categoryId === data[category]?.id &&
                        (fb?.comment?.replace(/<[^>]+>/g, "").trim() || fb?.rating > 0) && (
                          <div key={index}>
                            {fb?.rating > 0 && (
                              <p ><span className="question">Rating: </span> {fb?.rating} / 5</p>
                            )}
                            {fb?.comment && (
                              <>
                                <p className="question" style={{ marginTop: "10px", marginBottom: "0px" }} >
                                  Comment:
                                </p>
                                <div
                                  dangerouslySetInnerHTML={{ __html: fb.comment }}
                                />
                              </>
                            )}
                          </div>
                        )
                    )}
                  </div>
                )}

            </div>
          ))}
        </div>
      </div>
    </MainLayout>
  );
}

export default PreAssessmentView;
